(() => {
  document.querySelectorAll('[data-copy-code]').forEach(button => button.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText('TAPLY10'); button.textContent = 'Code copied'; }
    catch { button.textContent = 'TAPLY10'; }
  }));
  const menu = document.querySelector('.mobile-nav');
  if (!menu) return;
  const trigger = menu.querySelector('summary');
  const nav = menu.querySelector('nav');
  if (!trigger || !nav) return;
  const drawer = document.createElement('dialog');
  drawer.id = 'taply-sidebar';
  drawer.className = 'taply-sidebar';
  drawer.setAttribute('aria-labelledby', 'taply-sidebar-title');
  drawer.innerHTML = '<div class="sidebar-heading"><div><small>TAPLY.REVIEW</small><h2 id="taply-sidebar-title">Explore Taply</h2></div><button class="sidebar-close" type="button" aria-label="Close navigation"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button></div>';
  const seenDestinations = new Set();
  nav.querySelectorAll('a').forEach(link => {
    if (seenDestinations.has(link.href)) link.remove();
    else seenDestinations.add(link.href);
  });
  drawer.append(nav);
  const note = document.createElement('p');
  note.className = 'sidebar-note';
  note.textContent = 'One simple tap. No monthly fees.';
  drawer.append(note);
  document.body.append(drawer);
  trigger.setAttribute('aria-controls', drawer.id);
  trigger.setAttribute('aria-expanded', 'false');
  trigger.addEventListener('click', event => {
    event.preventDefault();
    if (drawer.open) return;
    drawer.showModal();
    document.documentElement.classList.add('sidebar-open');
    trigger.setAttribute('aria-expanded', 'true');
  });
  drawer.querySelector('.sidebar-close').addEventListener('click', () => drawer.close());
  nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => drawer.close()));
  drawer.addEventListener('click', event => {
    const rect = drawer.getBoundingClientRect();
    if (event.target === drawer && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) drawer.close();
  });
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('sidebar-open');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({preventScroll:true});
  });
  matchMedia('(min-width:901px)').addEventListener('change', event => { if (event.matches && drawer.open) drawer.close(); });
})();
